import moment from "moment";

import { BATCH_STATUS } from "./echeqMassManageConstants";
import { DEFAULT_LIST_ORDER_BY, DEFAULT_LIST_SORT_DIRECTION } from "./echeqMassManageListUtils";

const VALID_STATUSES = new Set(Object.values(BATCH_STATUS));
const VALID_ACTIONS = new Set(["ADMIT", "PAY"]);

/**
 * Convierte query string del link de notificación WEB en filtros del listado.
 */
export function buildListFiltersFromNotificationQuery(search = "") {
    const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
    const status = params.get("status");
    const action = params.get("action");
    const reference = params.get("reference") || "";
    const dateFrom = params.get("dateFrom");
    const dateTo = params.get("dateTo") || dateFrom;

    const parsedDateFrom =
        dateFrom && moment(dateFrom, "YYYY-MM-DD", true).isValid() ? dateFrom : moment().format("YYYY-MM-DD");
    const parsedDateTo = dateTo && moment(dateTo, "YYYY-MM-DD", true).isValid() ? dateTo : parsedDateFrom;

    return {
        status: status && VALID_STATUSES.has(status) ? status : "TODOS",
        action: action && VALID_ACTIONS.has(action) ? action : "TODOS",
        reference: reference.trim(),
        dateFrom: parsedDateFrom,
        dateTo: parsedDateTo,
        currency: "032",
        amountFrom: null,
        amountTo: null,
        pageNumber: 1,
        orderBy: DEFAULT_LIST_ORDER_BY,
        direction: DEFAULT_LIST_SORT_DIRECTION,
    };
}

export const MASS_ECHEQ_MANAGE_NOTIFICATION_LINK_PATH = "/echeqs/mass-management/:envId/:envName";

export function isMassEcheqManageNotificationLink(url = "") {
    return url.includes("/echeqs/mass-management/") && !url.includes("/v2/echeqs/mass-management");
}

export const MASS_ECHEQ_MANAGE_NOTIFICATION_WARNING_KEY = "echeq.massManage.notification.link.warning";
